import { z } from 'zod'

import type { User } from '@scalar-org/entities/user'

import type { RequestService } from '../request'

export function userApiFactory(requestService: RequestService) {
  async function update(data: Pick<User, 'theme'>) {
    return await requestService.request({
      url: 'core/user/update',
      method: 'post',
      schema: z.null(),
      data,
    })
  }

  return { update }
}
